/**
 * Customer Views API Route Definitions
 *
 * Zod-typed route definitions for the Customer Views CRUD API.
 */

import {
  CreateViewBodySchema,
  DuplicateViewBodySchema,
  ListViewsQuerySchema,
  ReorderViewsBodySchema,
  UpdateViewBodySchema,
  ViewDeleteResponseSchema,
  ViewDetailResponseSchema,
  ViewListResponseSchema,
  ViewPathVarsSchema
} from "./schemas";

export const ZCustomerViews = {
  List: {
    method: "GET" as const,
    path: "/api/customers/views",
    Query: ListViewsQuerySchema,
    Response: ViewListResponseSchema
  },
  Get: {
    method: "GET" as const,
    path: "/api/customers/views/:viewId",
    PathVars: ViewPathVarsSchema,
    Response: ViewDetailResponseSchema
  },
  Create: {
    method: "POST" as const,
    path: "/api/customers/views",
    Body: CreateViewBodySchema,
    Response: ViewDetailResponseSchema
  },
  Update: {
    method: "PATCH" as const,
    path: "/api/customers/views/:viewId",
    PathVars: ViewPathVarsSchema,
    Body: UpdateViewBodySchema,
    Response: ViewDetailResponseSchema
  },
  Delete: {
    method: "DELETE" as const,
    path: "/api/customers/views/:viewId",
    PathVars: ViewPathVarsSchema,
    Response: ViewDeleteResponseSchema
  },
  Duplicate: {
    method: "POST" as const,
    path: "/api/customers/views/:viewId/duplicate",
    PathVars: ViewPathVarsSchema,
    Body: DuplicateViewBodySchema,
    Response: ViewDetailResponseSchema
  },
  Reorder: {
    method: "PUT" as const,
    path: "/api/customers/views/reorder",
    Body: ReorderViewsBodySchema,
    Response: ViewListResponseSchema
  }
} as const;
